import { Link } from "react-router-dom";
import { Phone, MapPin, Clock, Instagram, Facebook } from "lucide-react";

const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-[#0A0A0A] border-t border-zinc-800">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <Link
              to="/"
              className="inline-block mb-6"
            >
              <img 
                src="/logo-arena.png" 
                alt="Arena Gym Logo" 
                className="h-16 w-auto"
              />
            </Link>
            <p className="text-zinc-400 text-sm leading-relaxed mb-6">
              Arena Private Gym. Professionele begeleiding voor
              jouw gezondheid en fitness doelen in Torhout.
            </p>
            <div className="flex gap-4">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                className="w-10 h-10 rounded-full bg-zinc-900 flex items-center justify-center text-zinc-400 hover:text-red-500 hover:bg-zinc-800 transition-all"
              >
                <Instagram size={18} />
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-facebook"
                className="w-10 h-10 rounded-full bg-zinc-900 flex items-center justify-center text-zinc-400 hover:text-red-500 hover:bg-zinc-800 transition-all"
              >
                <Facebook size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6 font-['Barlow_Condensed'] uppercase tracking-wide">
              Navigatie
            </h4>
            <ul className="space-y-3">
              {[
                { href: "/", label: "Home" },
                { href: "/over-ons", label: "Over Ons" },
                { href: "/diensten", label: "Diensten" },
                { href: "/team", label: "Team" },
                { href: "/reviews", label: "Reviews" },
                { href: "/contact", label: "Contact" },
              ].map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-zinc-400 hover:text-red-500 transition-colors text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6 font-['Barlow_Condensed'] uppercase tracking-wide">
              Diensten
            </h4>
            <ul className="space-y-3">
              {[
                "Personal Training",
                "Groepslessen",
                "Transformatietrajecten",
                "Voedingsbegeleiding",
                "Diëtiste begeleiding",
              ].map((service) => (
                <li key={service}>
                  <Link
                    to="/diensten"
                    className="text-zinc-400 hover:text-red-500 transition-colors text-sm"
                  >
                    {service}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6 font-['Barlow_Condensed'] uppercase tracking-wide">
              Contact
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
                <span className="text-zinc-400 text-sm">
                  Oostendestraat 114, 8820 Torhout, Belgium
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-red-500 flex-shrink-0" />
                <a
                  href="tel:0479380156"
                  data-testid="footer-phone"
                  className="text-zinc-400 hover:text-red-500 transition-colors text-sm"
                >
                  0479 38 01 56
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
                <div className="text-zinc-400 text-sm">
                  <p>Ma-Vr: 15:00–22:00</p>
                  <p>Za: 10:00–13:00</p>
                  <p>Zo: 10:30–12:00</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-zinc-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-zinc-500 text-sm">
            © 2026 Arena Private Gym. Alle rechten voorbehouden.
          </p>
          <div className="flex items-center gap-4">
            <span className="text-red-500 text-xs uppercase tracking-widest font-bold">
              4.9 ★ Google Rating
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
